export default "/fonts/line-awesome.eot?3400fa38b566632e63a76d3b766689ee";